import { graphql } from '../../gql';

const CompaniesQuery = graphql(/* GraphQL */ `
  query getCompaniesForCurrentUser {
    companiesForCurrentUser {
      id
      privileges
      name
      domain
    }
  }
`);

export { CompaniesQuery };
